/*
 * Milk Kitchen Form Library
 * Created: 2018-06-01
 * Version: 0.1.0
 * Copyright: 2018 Milk Kitchen Limited.
 * Author: Todd Hossack
 * Dependencies: jQuery, lodash
 */

if(typeof require === "function") {
    var _ = require('lodash');
    var $ = require('jquery');
}

class FormLib {

    static setFieldBusy($el, bool) {
        $el.each(function() {
            if (bool) {
                $el.addClass('field-busy');
            } else {
                $el.removeClass('field-busy');
            }
        });
    };

    /**
     * Finds form fields in specified form, optionally filtered by prefix.
     * @param array names
     * @param string prefix
     * @returns object
     */
    static findFields($form,prefix) {
        if(prefix) {
            return $form.find('input[name^="'+ prefix +'"],select[name^="'+ prefix +'"],textarea[name^="'+ prefix +'"]');
        } else {
            return $form.find('input,select,textarea'); 
        }
    };
    
    /**
     * Finds form field given name and optional prefix.
     * @param array names
     * @param string prefix
     * @returns object
     */
    static findField($form,name,prefix) {
        var field;
        // Ensure form element
        if(_.isString($form)) {
            $form = $($form);
        }
        // Make field name
        name = (prefix) ? prefix + '[' + name +']' : name;
        // Populate field
        field = $form[0].elements[name];
        return (field) ? $(field) : null;
    };
    
    static fieldDataName(fieldName) {
        var name,
            matches,
            regex = /[\w\-]+(\[\w\]+)?/g;

        if(fieldName) {
            matches = fieldName.match(regex);
            name = matches ? matches[matches.length - 1] : '';
        }

        return name;
    };
    
    /**
     * Populate form inputs based on selector value
     * @param {type} $form
     * @param {type} data
     * @param {type} prefix
     * @returns {Boolean}
     */
    static populate($fields,data) {
    
        var name,$field,self=this;

        if(!_.isObject(data) || !$fields || !$fields.length) {
            return false;
        }
        
        $fields.each(function() {
            $field = $(this);
            name = self.fieldDataName($(this).attr('name'));
            if(_.has(data,'name')) {
                $field.val(data[name]);
            }
        });
    };
    
    /**
     * Reset all fields in given form / container
     * @param object $form
     * @returns {undefined}
     */
    static reset($form) {
        // Ensure form/container element
        if(_.isString($form)) {
            $form = $($form);
        }
        return this.resetFields($form.find('input,select,textarea'));
    };
    
    /**
     * Sets options for select box
     * @param object $el - jQuery element
     * @param array data
     * @param int|string sel - Selected value
     */
    static setSelectOptions($el,options,sel) {
        if(options) {
            $el.append(options);
            if(sel) {
                $el.val(sel).trigger('change');
            }
        }
    };
    
    /**
     * Activates specified select box, populating with option data.
     * @param object $el - jQuery element
     * @param array data
     */
    static activateSelect($el,options) {
        $el.prop('disabled',false);
        if(options) {
            $el.append(options).trigger('change');
        }
    };
    
    
    /**
     * De-activates specified select box, clearing options
     * @param object $el - jQuery element
     * @param boolean clear - Remove existing options, except blank
     */
    static deactivateSelect($el,clear) {
        if(clear) {
            $el.val(null).find('optgroup,option').remove();
            $el.trigger('change');
        }
        $el.prop('disabled',true);
    };
    
    
    /**
     * Clears select box, optionally clearing options
     * @param object $el - jQuery element
     * @param boolean remove - Remove existing options, except blank
     */
    static clearSelect($el,remove) {
        $el.val('');
        if(remove) $el.find('optgroup,option').not('[value=""]').remove();
        $el.trigger('change');
    };

    /**
     * Resets given form fields
     * @param array $fields - jQuery elements
     */
    static toggleFields($fields,bool) {
        $.each($fields,function() {
            $(this).toggle(bool);
        });
    }
    
    /**
     * Resets given form fields
     * @param array fields - elements or jquery elements
     */
    static resetFields(fields) {
        var type;
        $.each(fields,function() {
            switch(this.nodeName || this.tagName) {
                case 'INPUT':
                    type = $(this).attr('type');
                    if(type === 'radio' || type === 'checkbox') {
                        $(this).prop('checked',false);
                    } else if(type === 'text' || type === 'number') {
                        $(this).val('');
                    }
                    break;
                case 'SELECT':
                    $(this)
                        .val(null)
                        .find('optgroup,option')
                        .not('[value=""]')
                        .prop('selected',false)
                        .end()
                        .find('option:first')
                        .prop('selected',true);
                   $(this).trigger('change');
                        /*
                    $(this).find('option')
                        .prop('selected',false)
                        .end()
                        .find('option:first')
                        .prop('selected',true);
                        */
                    break;
                case 'TEXTAREA':
                    $(this).val('');
                    break;
            }
        });
    };
 
    /**
     * Disables/enables given form fields
     * @param array $fields - jQuery elements
     * @param boolean bool
     */
    static toggleDisabled($fields,bool) {
        $.each($fields,function() {
            $(this).prop('disabled',bool);
        });
    };
    
    /**
     * Create form options given a collection 
     * @param array - objects with id keys. ie. [{id: [id], text: [string]}]
     * @param options - object with options: 
     *      selectedIds - int|array of ids which are selected
     *      disabledIds - int|array of ids which are disabled
     *      makeList - boolean Prepares list from data using Lib.Helpers.makeList
     *  Additionally, you may include makeList options passed on when preparing list.
     * @see Helpers.makeList
     * @return array - see https://select2.org/data-sources/formats
     */
    static createSelectOptions(data,options) {
        var opts,list,id,text,option,selectedIds,defaultSelected,selected,out = [];
        var Helpers = require('./helpers.js');
        opts = _.defaults(options,{
           selectedIds: [],
           defaultSelected: null,
           makeList: false
        });
        opts.keyed = false;

        if(opts.makeList) {
            data = Helpers.makeList(data,opts);
        }

        selectedIds = !_.isArray(opts.selectedIds) ? [opts.selectedIds] : opts.selectedIds;
        var iterator = _.isObject(data) ? _.forIn : _.forEach;
        iterator(data,function(v) {
            id = _.has(v,'id') ? v.id : '';
            text = _.has(v,'text') ? Helpers.escapeHtml(v.text) : '';
            defaultSelected = (defaultSelected && id == defaultSelected) ? true : false;
            selected = (_.indexOf(selectedIds,id) !== -1) ? true : false;
            if((id + '').length) {
                option = new Option(text,id,defaultSelected,selected);
                out.push(option);
            }
        });
        return out;
    };
    
    
    static createSelectOptionsHtml(data,options) {
        var opts,list,id,text,option,selectedIds,defaultSelected,selected,out = '';
        var self = this;
        var Helpers = require('./helpers.js');
        opts = _.defaults(options,{
            empty: false,
            selectedIds: [],
            defaultSelected: null,
            makeList: false
        });
        opts.keyed = false;
        if(opts.makeList) {
            data = Helpers.makeList(data,opts);
        }
        
        selectedIds = !_.isArray(opts.selectedIds) ? [opts.selectedIds] : opts.selectedIds;
        var iterator = _.isArray(data) ? _.forEach : _.forIn;

        if(opts.empty !== false) {
            out += self.renderOption({id: null, text: opts.empty});
        }
        iterator(data,function(v) {
            // Optgroup
            if(_.has(v,'options')) {
                out += self.renderOptgroup(v);
            } 
            // Option
            else {
                out += self.renderOption(v,selectedIds);
            }
        });
        return out;
    };
    
    static renderOptgroup(data,selectedIds) {
        var Helpers = require('./helpers.js');
        var text = _.has(data,'text') ? Helpers.escapeHtml(data.text) : '',
            self = this,
            out = '',
            options = _.has(data,'options') ? data.options : [];
    
        if(options.length) {
            out += '<optgroup label="'+ text +'" >';
            _.forEach(options,function(option) {
                out += self.renderOption(option,selectedIds);
            });
            out += '</optgroup>';
        }
        
        return out;
    };
    
    static renderOption(data,selectedIds) {
        var Helpers = require('./helpers.js');
        // No id, no option
        if(!_.has(data,'id')) return '';

        var id = _.isNull(data.id) ? '' : data.id,
            text = (!_.has(data,'text')) ? '' : (
                _.isString(data.text) ?  Helpers.escapeHtml(data.text) : data.text
            ),
            option = '';

        var selected = (_.indexOf(selectedIds,id) !== -1) ? true : false;
        option += '<option value="'+ id +'" ';
        if(selected) {
            option += 'selected="selected"';
        }
        option += ' >' + text + '</option>';

        return option;
    };
    
    /**
     * Converts keyed object into select2 data format
     * @param array - objects with id keys. ie. [{id: text}]
     * @param selectedIds - int|array of ids which are selected
     * @param disabledIds - int|array of ids which are disabled
     * @return array - see https://select2.org/data-sources/formats
     */
    static formatSelect2Options(data,selectedIds,disabledIds) {
        var option,out = [];
        selectedIds = !selectedIds ? [] : !_.isArray(selectedIds) ? [selectedIds] : selectedIds;
        disabledIds = !disabledIds ? [] : !_.isArray(disabledIds) ? [disabledIds] : disabledIds;
        _.forEach(data,function(v,k) {
            option = { id: k, text: v };
            if(_.indexOf(selectedIds,k) !== -1) {
                option.selected = true;
            }
            if(_.indexOf(disabledIds,k) !== -1) {
                option.disabled = true;
            }
            out.push(option);
        });
        return out;
    };
    
    /**
     * 
     * @param ResourceLoader loader
     * @param jQuery object $fields
     * @param integer|array id
     * @param object options
     * @returns {Boolean}
     */
    static loadAndPopulate(loader,$fields,id,options) {
        var self = this;
        options = _.extend({
            disabled: true,
            reset: true,
            callback: null
        }, options || {});

        if(!loader) {
            return false;
        }
        // If numeric id selected
        if(id.match(/^\d+$/)) {
            options.disabled = true;
            // Defaults
            var defaultFetchOptions = {
                searchKey: 'id',
                done: function() {
                    if(typeof options.callback === 'function') {
                        options.callback($fields,loader);
                    } else {
                        self.populate($fields,loader.findItem(id));
                        self.toggleDisabled($fields,options.disabled);
                    }
                }
            };
            var fetchOptions = _.extend(defaultFetchOptions,_.pick(options,['searchKey','done']));
            // Fetch items, allowing customised options
            loader.fetchItems(id,fetchOptions);
        } 
        // Input entered or cleared
        else {
            options.disabled = false;
            if(options.reset) {
                this.resetFields($fields);
            }
            this.toggleDisabled($fields,options.disabled);
        }
    }
  
}

if(typeof module === "object" && typeof module.exports === "object") {
    var exports = module.exports = FormLib;
}


// WEBPACK FOOTER //
// ./client/src/js/lib/form.js